import { PaymentGatewayTransactionListResponse } from "../entities/company/PaymentProvider/PaymentGatewayTransactionListResponse";
import { PaymentLinkTransactionLogResponse } from "../entities/company/PaymentProvider/PaymentLinkTransactionLog";
import RequestService from "./RequestService";

class PaymentGatewayTransactionService {
  /**
   * Obtiene el historial de transacciones de la pasarela de pagos
   * GET /paymentlinktransaction/paymentsbycompany
   * @param page Número de página (0-indexed)
   * @param pageSize Tamaño de página
   */
  public static getList(
    page: number,
    pageSize: number
  ): Promise<Error | PaymentGatewayTransactionListResponse> {
    return RequestService.get("/paymentlinktransaction/paymentsbycompany", {
      page,
      pagesize: pageSize
    });
  }

  /**
   * Obtiene el log de webhook de una transacción
   * GET /paymentlinktransaction/getpaymentlinkTransactionlog/{paymentLinkTransactionId}
   * @param paymentLinkTransactionId ID de la transacción
   */
  public static getPaymentLinkTransactionLog(
    paymentLinkTransactionId: number
  ): Promise<Error | PaymentLinkTransactionLogResponse> {
    return RequestService.get(
      `/paymentlinktransaction/getpaymentlinkTransactionlog/${paymentLinkTransactionId}`,
      {}
    );
  }
}

export default PaymentGatewayTransactionService;
